import BCButtonDropdown from "../ui/BCButtonDropdown";

const BWExportButton = () => {
    const handleOptionsChange = async (index) => {
        if (BPExportOptions[index].value === "CSV") {
            console.log("CSV format export"); // TODO: need api that export table in CSV format
        }
        else if (BPExportOptions[index].value === "Excel") {
            console.log("Excel format export"); // TODO: need api that export table in Excel format
        }
        else {
            console.log("PDF format export"); // TODO: need api that export table in PDF format
        }
    };

    const BPExportOptions = [
        { key: "CSV", icon: "file alternate outline", text: "CSV", value: "CSV" },
        { key: "Excel", icon: "file excel outline", text: "Excel", value: "Excel" },
        { key: "PDF", icon: "file pdf outline", text: "PDF", value: "PDF" },
    ];

    return (
        <BCButtonDropdown
            buttonClass="borrower-dropdown-button"
            buttonGroupText="Export"
            buttonGroupClass="bc-button-group prescreen-button-group"
            handleOptionClick={handleOptionsChange}
            options={BPExportOptions}
            dropdownMenuClass="export-button-dropdown"
        />
    );
};

export default BWExportButton;
